import { datadogLogs } from "@datadog/browser-logs";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { getUrlParams } from "./utils/getUrlParams";

if (process.env.NODE_ENV === "production") {
  console.log("Datadog initialised");
  datadogLogs.init({
    // @ts-expect-error following documentation
    beforeSend: (log) => {
      // remove jwt from view url
      log.view.url = log.view.url.replace(/jwt=[^&]*/, "jwt=REDACTED");
      // remove jwt from view url_details
      if (
        typeof log.view.url_details === "object" &&
        log.view.url_details !== null &&
        "queryString" in log.view.url_details
      ) {
        (log.view.url_details as { queryString: { jwt: string } }).queryString.jwt =
          "REDACTED";
      }
    },
    clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
    forwardConsoleLogs: "all",
    forwardErrorsToLogs: true,
    service: "px-qualification-app",
    sessionSampleRate: 100,
    site: "datadoghq.eu",
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("valuation-manager-widget") as HTMLElement,
);
const appInput = getUrlParams();
root.render(
  <React.StrictMode>
    <App appInput={appInput} />
  </React.StrictMode>,
);
